import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';
import { CachedCallService } from './cached-call.service';

import { TranslationKey } from '../../entities/translation-key';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class TranslationKeyService {

  private static readonly translationKeysBaseUrl:string = `${Settings.apiUrl}/v1/TranslationKeys`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getTranslationKeys(): Promise<TranslationKey[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(TranslationKeyService.translationKeysBaseUrl);

    oDataBuilder.expand("TranslationCategory");

    let translationKeyUrl: string = oDataBuilder.toString();

    return this.http.get(translationKeyUrl)
      .toPromise()
      .then(response => response.json().value)
      .then(translationKeys => {
        return translationKeys;
      });
  }

  getTranslationKeysByTranslationCategoryId(translationCategoryId:number): Promise<TranslationKey[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(TranslationKeyService.translationKeysBaseUrl);

    oDataBuilder
      .filter('TranslationCategoryId', ODataComparer.Equals, translationCategoryId)
      .expand("TranslationCategory")
      .orderBy('SortOrder');

    let translationKeyUrl: string = oDataBuilder.toString();

    return this.http.get(translationKeyUrl)
      .toPromise()
      .then(response => response.json().value)
      .then(translationKeys => {
        return translationKeys;
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/translation-key.service.ts